// extracted by mini-css-extract-plugin
export default {"download":"download___domaL9n"};